import * as React from "react";
import axios from "axios";
import { config } from "../../../config/config.jsx";
import CryptoJS from "crypto-js";
import { format } from "date-fns"; // Add this import for date formatting
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  ArrowsUpDownIcon,
  ArrowUpIcon,
  ArrowDownIcon,
} from "@heroicons/react/24/solid";
import { Empty, Modal } from "antd";
import { InboxOutlined, DownloadOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const CoatofArmUrl = new URL("../../assets/images/coat-of-arm.png", import.meta.url).href;
const NIMCUrl = new URL("../../assets/images/nimc-1.png", import.meta.url).href;

function buildBasicNINSlipHTML(userData, coatSrc, nimcSrc) {
  var avatarSrc = userData.photo ? "data:image/jpeg;base64," + userData.photo : "";
  var avatarTag = avatarSrc
    ? '<img src="' + avatarSrc + '" alt="Profile" style="width:120px;height:120px;object-fit:cover;border-radius:50%;margin-top:20px;" crossorigin="anonymous" />'
    : "";
  var genderLabel = userData.gender === "m" ? "Male" : "Female";
  return (
    '<div style="background:white;padding:32px;width:850px;font-family:Arial,sans-serif;border:1px solid #ccc;margin:auto;">'
    + '<header style="display:flex;justify-content:center;align-items:center;gap:20px;margin-bottom:12px;">'
    + '<img src="' + coatSrc + '" alt="Coat of Arms" style="width:92px;height:60px;" crossorigin="anonymous" />'
    + '<p style="font-size:18px;color:#4B5563;font-weight:bold;margin:0;">Federal Republic of Nigeria</p>'
    + '<img src="' + nimcSrc + '" alt="NIMC logo" style="width:80px;height:48px;" crossorigin="anonymous" />'
    + '</header>'
    + '<h2 style="font-size:18px;color:#4B5563;font-weight:bold;text-align:center;margin-bottom:16px;">Verified NIN Details</h2>'
    + '<div style="display:flex;justify-content:space-between;align-items:flex-start;gap:20px;">'
    + '<div style="flex:1;">'
    + '<div style="display:flex;gap:20px;margin-top:12px;">'
    + '<div style="flex:1;display:grid;gap:8px;">'
    + '<div style="display:flex;"><span style="color:#374151;font-weight:600;width:100px;display:inline-block;font-size:11px;">First Name:</span><span style="color:#4B5563;font-size:11px;">' + (userData.firstname || "") + '</span></div>'
    + '<div style="display:flex;"><span style="color:#374151;font-weight:600;width:100px;display:inline-block;font-size:11px;">Middle Name:</span><span style="color:#4B5563;font-size:11px;">' + (userData.middlename || "") + '</span></div>'
    + '<div style="display:flex;"><span style="color:#374151;font-weight:600;width:100px;display:inline-block;font-size:11px;">Surname:</span><span style="color:#4B5563;font-size:11px;">' + (userData.surname || "") + '</span></div>'
    + '<div style="display:flex;"><span style="color:#374151;font-weight:600;width:100px;display:inline-block;font-size:11px;">Date of Birth:</span><span style="color:#4B5563;font-size:11px;">' + (userData.birthdate || "") + '</span></div>'
    + '<div style="display:flex;"><span style="color:#374151;font-weight:600;width:100px;display:inline-block;font-size:11px;">Gender:</span><span style="color:#4B5563;font-size:11px;">' + genderLabel + '</span></div>'
    + '<div style="margin-top:8px;margin-bottom:8px;"><h1 style="font-size:14px;color:#6B7280;margin:0;">NIN Number: <span style="background:#4ADE80;color:black;padding:4px;font-weight:600;">' + (userData.nin || "") + '</span></h1></div>'
    + '<div style="display:flex;gap:12px;margin-top:12px;">'
    + '<div style="display:grid;gap:8px;">'
    + '<div style="display:flex;"><span style="color:#374151;font-weight:600;width:100px;display:inline-block;font-size:11px;">Phone Number:</span><span style="color:#4B5563;font-size:11px;">' + (userData.telephoneno || "") + '</span></div>'
    + '<div style="display:flex;"><span style="color:#374151;font-weight:600;width:100px;display:inline-block;font-size:11px;">Residence State:</span><span style="color:#4B5563;font-size:11px;">' + (userData.residence_state || "") + '</span></div>'
    + '<div style="display:flex;"><span style="color:#374151;font-weight:600;width:100px;display:inline-block;font-size:11px;">Birth State:</span><span style="color:#4B5563;font-size:11px;">' + (userData.birthstate || "") + '</span></div>'
    + '<div style="display:flex;"><span style="color:#374151;font-weight:600;width:100px;display:inline-block;font-size:11px;">Address:</span><span style="color:#4B5563;font-size:11px;">' + (userData.residence_address || "") + '</span></div>'
    + '</div>'
    + '<div style="display:grid;gap:8px;">'
    + '<div style="display:flex;"><span style="color:#374151;font-weight:600;width:100px;display:inline-block;font-size:11px;">Residence LGA:</span><span style="color:#4B5563;font-size:11px;">' + (userData.residence_lga || "") + '</span></div>'
    + '<div style="display:flex;"><span style="color:#374151;font-weight:600;width:100px;display:inline-block;font-size:11px;">Birth LGA:</span><span style="color:#4B5563;font-size:11px;">' + (userData.birthlga || "") + '</span></div>'
    + '</div>'
    + '</div>'
    + '</div>'
    + '<div style="width:130px;text-align:center;">' + avatarTag + '</div>'
    + '</div>'
    + '</div>'
    + '<div style="flex:1;">'
    + '<h4 style="color:#16A34A;font-size:18px;text-align:center;margin-top:0;margin-bottom:8px;">Verified</h4>'
    + '<p style="font-size:10px;color:#4B5563;text-align:center;margin:0 0 4px 0;">This is a property of National Identity Management Commission (NIMC), Nigeria.</p>'
    + '<p style="font-size:10px;color:#4B5563;text-align:center;margin:0 0 8px 0;">If found, please return to the nearest NIMC office or contact +234 815 769 1214.</p>'
    + '<ol style="font-weight:600;font-size:10px;color:#4B5563;margin-top:8px;padding-left:20px;line-height:1.4;">'
    + '<li style="margin-bottom:8px;">This NIN slip remains the property of the Federal Republic of Nigeria and MUST be surrendered on demand.</li>'
    + '<li style="margin-bottom:8px;">This NIN slip does not imply nor confer citizenship on the holder.</li>'
    + '<li style="margin-bottom:8px;">This NIN slip is valid for the lifetime of the holder and <span style="color:#EF4444;font-weight:bold;">DOES NOT EXPIRE</span>.</li>'
    + '</ol>'
    + '</div>'
    + '</div>'
    + '</div>'
  );
}

// Add your secret key for decryption
const SECRET_KEY = import.meta.env.VITE_APP_SECRET_KEY;

function decryptData(ciphertext) {
  if (!ciphertext) return null;
  try {
    const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decrypted);
  } catch {
    return null;
  }
}

export default function VerificationsHistoryTable() {
  const navigate = useNavigate();

  // Get encrypted user data from localStorage
  const encryptedUser = localStorage.getItem("user");
  const user = decryptData(encryptedUser);
  const userId = user?.id || user?._id;

  // Set the API link using the userId
  const apiLink = `${config.apiBaseUrl}${config.endpoints.DataHistory}${userId}`;

  const [loading, setLoading] = React.useState(false);
  const [apiData, setApiData] = React.useState([]);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [startDate, setStartDate] = React.useState(null);
  const [endDate, setEndDate] = React.useState(null);
  const [sortConfig, setSortConfig] = React.useState({
    key: "createdAt",
    direction: "desc",
  });
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [selectedTransaction, setSelectedTransaction] = React.useState(null);
  const [pageSize, setPageSize] = React.useState(10);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [downloadingId, setDownloadingId] = React.useState(null);

  const downloadBasicNINSlip = async (transaction) => {
    const transactionId = transaction._id;
    setDownloadingId(transactionId);
    let iframe = null;
    try {
      const userData = transaction.data?.data || transaction.data?.nin_data;
      if (!userData) { setDownloadingId(null); return; }

      const slipHTML = buildBasicNINSlipHTML(userData, CoatofArmUrl, NIMCUrl);
      const iframeContent = "<!DOCTYPE html><html><head><style>" +
        "* { margin: 0; padding: 0; box-sizing: border-box; }" +
        "html, body { background: white; font-family: Arial, sans-serif; width: 100%; }" +
        "</style></head><body>" + slipHTML + "</body></html>";

      iframe = document.createElement("iframe");
      iframe.style.cssText = "position:fixed;left:-9999px;top:-9999px;width:1800px;height:1200px;border:none;visibility:hidden;";
      document.body.appendChild(iframe);
      iframe.setAttribute("width", "1800");
      iframe.setAttribute("height", "1200");

      const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
      iframeDoc.open();
      iframeDoc.write(iframeContent);
      iframeDoc.close();

      const images = iframeDoc.querySelectorAll("img");
      await Promise.all(Array.from(images).map((img) => new Promise((resolve) => {
        if (img.complete) resolve(); else { img.onload = resolve; img.onerror = resolve; }
      })));
      await new Promise((resolve) => setTimeout(resolve, 400));

      const targetEl = iframeDoc.body.firstElementChild;
      const elWidth = targetEl.scrollWidth;
      const elHeight = targetEl.scrollHeight;
      const canvas = await html2canvas(targetEl, {
        scale: 2, useCORS: true, allowTaint: true, backgroundColor: "#ffffff",
        width: elWidth, height: elHeight, windowWidth: elWidth + 100, windowHeight: elHeight + 100,
      });

      const imgData = canvas.toDataURL("image/png");
      const pxToMm = 25.4 / 96;
      const pdfWidth = (canvas.width / 2) * pxToMm + 10;
      const pdfHeight = (canvas.height / 2) * pxToMm + 10;
      const pdf = new jsPDF({
        orientation: pdfWidth > pdfHeight ? "landscape" : "portrait",
        unit: "mm",
        format: [pdfWidth, pdfHeight],
      });
      pdf.addImage(imgData, "PNG", 5, 5, pdfWidth - 10, pdfHeight - 10);
      const nin = userData.nin || "unknown";
      const fn = userData.firstname || "";
      const sn = userData.surname || "";
      pdf.save("NIN_Slip_" + fn + "_" + sn + "_" + nin + ".pdf");
    } catch (error) {
      
    } finally {
      if (iframe && iframe.parentNode) iframe.parentNode.removeChild(iframe);
      setDownloadingId(null);
    }
  };

  const fetchVerificationHistory = async () => {
    if (!userId) return;

    setLoading(true);
    try {
      const response = await axios.get(apiLink, {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        },
      });

      const details = response.data?.findData || [];
      

      setApiData(details || []);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  // Filter transactions based on search term and only show credit transactions
  // Modify the filteredTransactions to only show IPE-Slip data
  const filteredTransactions = apiData.filter((transaction) => {
    // First filter for IPE-Slip only
    if (transaction.dataFor !== "NIN-Slip") return false;

    const searchStr = searchTerm.toLowerCase();
    const transactionDate = new Date(transaction.createdAt);

    // Date filter
    const passesDateFilter =
      (!startDate || transactionDate >= startDate) &&
      (!endDate || transactionDate <= endDate);

    // Text search filter for BVN specific fields
    const passesSearchFilter =
      transaction.slipLayout?.toLowerCase().includes(searchStr) ||
      transaction.data?.reference?.toLowerCase().includes(searchStr) ||
      transaction.data?.status?.toLowerCase().includes(searchStr) ||
      transaction.data?.data?.firstName?.toLowerCase().includes(searchStr) ||
      transaction.data?.data?.lastName?.toLowerCase().includes(searchStr) ||
      transaction.data?.detail?.toLowerCase().includes(searchStr);

    return passesDateFilter && passesSearchFilter;
  });

  const sortData = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const getSortedData = (data) => {
    if (!sortConfig.key) return data;

    return [...data].sort((a, b) => {
      if (sortConfig.key === "createdAt") {
        const dateA = new Date(a[sortConfig.key]);
        const dateB = new Date(b[sortConfig.key]);
        return sortConfig.direction === "asc" ? dateA - dateB : dateB - dateA;
      }

      if (a[sortConfig.key] < b[sortConfig.key]) {
        return sortConfig.direction === "asc" ? -1 : 1;
      }
      if (a[sortConfig.key] > b[sortConfig.key]) {
        return sortConfig.direction === "asc" ? 1 : -1;
      }
      return 0;
    });
  };

  // Create a reusable header component
  const TableHeader = ({ label, sortKey, className }) => {
    const isSorted = sortConfig.key === sortKey;
    const icon = isSorted ? (
      sortConfig.direction === "asc" ? (
        <ArrowUpIcon className="w-4 h-4 text-blue-600" />
      ) : (
        <ArrowDownIcon className="w-4 h-4 text-blue-600" />
      )
    ) : (
      <ArrowsUpDownIcon className="w-4 h-4 text-gray-400" />
    );

    return (
      <th
        scope="col"
        className={`${className} cursor-pointer hover:bg-gray-50`}
        onClick={() => sortKey && sortData(sortKey)}
      >
        <div className="flex items-center justify-between">
          <span>{label}</span>
          <span className="ml-2">{icon}</span>
        </div>
      </th>
    );
  };

  const showModal = (transaction) => {
    setSelectedTransaction(transaction);
    setIsModalVisible(true);
  };

  const handleDownloadSlip = (transaction) => {
    try {
      let pdfBase64 = null;

      if (transaction.pdf_base64) {
        pdfBase64 = transaction.pdf_base64;
      } else if (transaction.data?.pdf_base64) {
        pdfBase64 = transaction.data.pdf_base64;
      } else if (transaction.data?.data?.pdf_base64) {
        pdfBase64 = transaction.data.data.pdf_base64;
      } else if (transaction.pdfBase64) {
        pdfBase64 = transaction.pdfBase64;
      } else if (transaction.data?.pdfBase64) {
        pdfBase64 = transaction.data.pdfBase64;
      }

      if (pdfBase64) {
        let cleanBase64 = pdfBase64.replace(/\s/g, "");
        if (cleanBase64.startsWith("data:")) {
          cleanBase64 = cleanBase64.split(",")[1];
        }

        const binaryString = window.atob(cleanBase64);
        const bytes = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }

        const blob = new Blob([bytes], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = `${transaction.slipLayout || transaction.dataFor || "slip"}-${Date.now()}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } else if (transaction.slipLayout === "basic") {
        downloadBasicNINSlip(transaction);
      } else {
        alert("PDF document is not available for immediate download.");
      }
    } catch (err) {
      
      alert("Failed to download the document.");
    }
  };

  React.useEffect(() => {
    fetchVerificationHistory();
  }, [userId]);

  const sortedTransactions = getSortedData(filteredTransactions);

  // Pagination logic
  const paginatedData = sortedTransactions.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const totalPages = Math.ceil(sortedTransactions.length / pageSize);

  return (
    <div className="p-4 w-full">
      <h2 className="text-[clamp(1.2rem,2vw,2rem)] font-bold mb-4">
        NIN Verification History
      </h2>

      

      {/* Loading Spinner */}
      {loading && (
        <div className="flex justify-center items-center h-64">
          <div className="flex flex-col items-center space-y-4">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
            <p className="text-gray-500 text-sm">
              Loading NIN verification history...
            </p>
          </div>
        </div>
      )}

      {!loading && sortedTransactions.length > 0 ? (
        <div className="relative overflow-hidden rounded-lg border border-gray-200 shadow">
          <div className="overflow-x-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
            <table className="w-full table-auto divide-y divide-gray-200 transition-all duration-300 ease-in-out min-w-[800px] [&_th]:border [&_th]:border-gray-200 [&_td]:border [&_td]:border-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="w-[60px] px-2 py-2 text-left text-[clamp(0.65rem,1vw,0.75rem)] font-medium text-gray-500 uppercase tracking-wider border-b border-gray-200">
                    S/N
                  </th>
                  <th className="w-[120px] px-2 py-2 text-left text-[clamp(0.65rem,1vw,0.75rem)] font-medium text-gray-500 uppercase tracking-wider border-b border-gray-200">
                    NIN
                  </th>
                  <th className="w-[100px] px-2 py-2 text-left text-[clamp(0.65rem,1vw,0.75rem)] font-medium text-gray-500 uppercase tracking-wider border-b border-gray-200">
                    STATUS
                  </th>
                  <th className="w-[100px] px-2 py-2 text-left text-[clamp(0.65rem,1vw,0.75rem)] font-medium text-gray-500 uppercase tracking-wider border-b border-gray-200">
                    Download slip
                  </th>
                  <TableHeader
                    label="Date"
                    sortKey="createdAt"
                    className="w-[clamp(80px,15vw,112px)] px-2 py-2 text-left text-[clamp(0.65rem,1vw,0.75rem)] font-medium text-gray-500 uppercase tracking-wider border-b border-gray-200"
                  />
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {paginatedData.map((transaction, index) => (
                  <tr
                    key={transaction._id || index}
                    className="hover:bg-gray-50 transition-colors"
                  >
                    <td className="w-[60px] px-2 py-2 whitespace-nowrap text-[clamp(0.8rem,1vw,0.75rem)] text-gray-900">
                      {(currentPage - 1) * pageSize + index + 1}
                    </td>
                    <td className="w-[120px] py-2 whitespace-nowrap">
                      <span className="inline-flex items-center px-2 py-0.5 rounded-full text-sm font-bold tracking-widest capitalize text-gray-800">
                        {(() => {
                          const ninVal = transaction.data?.user_data?.searchParameter || transaction.data?.user_data?.nin || transaction.data?.data?.nin || transaction.data?.nin_data?.nin;
                          return ninVal ? String(ninVal) : "N/A";
                        })()}
                      </span>
                    </td>
                    <td className="w-[100px] px-2 py-2 whitespace-nowrap">
                      <span className={`text-[11px] font-medium px-2 py-0.5 rounded-full inline-block ${['success', 'successful', 'verified'].includes(String(transaction.data?.user_data?.transactionStatus || transaction.data?.verification_status || (typeof transaction.data?.status === 'boolean' ? (transaction.data?.status ? 'verified' : 'failed') : transaction.data?.status) || "").toLowerCase()) ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'}`}>
                        {(() => {
                          const raw = transaction.data?.user_data?.transactionStatus
                            || (typeof transaction.data?.status === 'boolean' ? (transaction.data?.status ? 'verified' : 'failed') : transaction.data?.status)
                            || transaction.data?.verification_status || "N/A";
                          return String(raw).toLowerCase() === 'verified' ? 'SUCCESSFUL' : raw;
                        })()}
                      </span>
                    </td>
                    <td className="w-[100px] px-2 py-2 whitespace-nowrap">
                      {transaction.dataFor !== "IPE-Slip" ? (
                        <button
                          onClick={() => handleDownloadSlip(transaction)}
                          disabled={downloadingId === transaction._id}
                          className="text-blue-600 hover:text-blue-800 underline font-medium transition-colors disabled:opacity-50"
                        >
                          {downloadingId === transaction._id ? 'Downloading...' : '[download]'}
                        </button>
                      ) : (
                        <span className="text-gray-400">N/A</span>
                      )}
                    </td>
                    <td className="w-[clamp(80px,15vw,112px)] px-2 py-2 whitespace-nowrap text-[clamp(0.8rem,1vw,0.75rem)] text-gray-900">
                      {format(
                        new Date(transaction.createdAt),
                        "dd/MM/yyyy"
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : !loading ? (
        <div className="flex flex-col items-center justify-center p-8">
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            imageStyle={{ height: 60 }}
            description={
              <div className="text-center">
                <p className="text-gray-500 text-lg mb-2">
                  No Transaction Records Found
                </p>
                <p className="text-gray-400 text-sm">
                  Your transaction history will appear here
                </p>
              </div>
            }
          />
        </div>
      ) : null}

      {/* Pagination Controls - only show when not loading and has data */}
      {!loading && sortedTransactions.length > 0 && (
        <div className="mt-4 flex flex-col lg:flex-row gap-4 items-center justify-between">
          {/* Rows per page and showing entries */}
          <div className="flex flex-col sm:flex-row items-center gap-2 w-full lg:w-auto">
            <div className="flex items-center gap-2">
              <span className="text-sm text-gray-700 whitespace-nowrap">
                Rows per page:
              </span>
              <select
                value={pageSize}
                onChange={(e) => {
                  setPageSize(Number(e.target.value));
                  setCurrentPage(1);
                }}
                className="border rounded-md px-2 py-1 text-sm transition-colors duration-200 ease-in-out hover:border-blue-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
            </div>
            <span className="text-sm text-gray-700 text-center sm:text-left">
              Showing {(currentPage - 1) * pageSize + 1} to{" "}
              {Math.min(currentPage * pageSize, sortedTransactions.length)} of{" "}
              {sortedTransactions.length} entries
            </span>
          </div>

          {/* Pagination buttons */}
          <div className="flex flex-wrap items-center justify-center gap-2">
            <button
              onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
              disabled={currentPage === 1}
              className={`px-3 py-1 rounded-md transition-all duration-200 ease-in-out transform hover:scale-105 min-w-[80px] ${
                currentPage === 1
                  ? "bg-gray-100 text-gray-400"
                  : "bg-blue-500 text-white hover:bg-blue-600"
              }`}
            >
              Previous
            </button>

            <div className="flex flex-wrap items-center gap-1 max-w-[calc(100vw-2rem)] overflow-x-auto">
              {totalPages <= 7 ? (
                // Show all pages if total pages are 7 or less
                [...Array(totalPages)].map((_, i) => (
                  <button
                    key={i + 1}
                    onClick={() => setCurrentPage(i + 1)}
                    className={`px-3 py-1 rounded-md transition-all duration-200 ease-in-out transform hover:scale-105 ${
                      currentPage === i + 1
                        ? "bg-blue-500 text-white"
                        : "bg-gray-100 hover:bg-gray-200"
                    }`}
                  >
                    {i + 1}
                  </button>
                ))
              ) : (
                // Show truncated pagination for more than 7 pages
                <>
                  {[...Array(Math.min(3, totalPages))].map((_, i) => (
                    <button
                      key={i + 1}
                      onClick={() => setCurrentPage(i + 1)}
                      className={`px-3 py-1 rounded-md transition-all duration-200 ease-in-out transform hover:scale-105 ${
                        currentPage === i + 1
                          ? "bg-blue-500 text-white"
                          : "bg-gray-100 hover:bg-gray-200"
                      }`}
                    >
                      {i + 1}
                    </button>
                  ))}
                  {currentPage > 4 && <span className="px-2">...</span>}
                  {currentPage > 3 && currentPage < totalPages - 2 && (
                    <button className="px-3 py-1 rounded-md bg-blue-500 text-white">
                      {currentPage}
                    </button>
                  )}
                  {currentPage < totalPages - 3 && (
                    <span className="px-2">...</span>
                  )}
                  {[...Array(Math.min(2, totalPages))].map((_, i) => (
                    <button
                      key={totalPages - 1 + i}
                      onClick={() => setCurrentPage(totalPages - 1 + i)}
                      className={`px-3 py-1 rounded-md transition-all duration-200 ease-in-out transform hover:scale-105 ${
                        currentPage === totalPages - 1 + i
                          ? "bg-blue-500 text-white"
                          : "bg-gray-100 hover:bg-gray-200"
                      }`}
                    >
                      {totalPages - 1 + i}
                    </button>
                  ))}
                </>
              )}
            </div>

            <button
              onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
              disabled={currentPage === totalPages}
              className={`px-3 py-1 rounded-md transition-all duration-200 ease-in-out transform hover:scale-105 min-w-[80px] ${
                currentPage === totalPages
                  ? "bg-gray-100 text-gray-400"
                  : "bg-blue-500 text-white hover:bg-blue-600"
              }`}
            >
              Next
            </button>
          </div>
        </div>
      )}

      {/* Add Modal */}
      <Modal
        title="Verification Details"
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        width={600}
      >
        {selectedTransaction && (
          <div className="space-y-4">
            {selectedTransaction.dataFor === "IPE-Slip" ? (
              // IPE-Slip specific details
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <p className="text-sm font-medium text-gray-500">Date</p>
                  <p className="mt-1 text-sm text-gray-900">
                    {format(
                      new Date(selectedTransaction.createdAt),
                      "dd/MM/yyyy"
                    )}
                  </p>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-500">Status</p>
                  <span className="mt-1 text-sm font-medium capitalize px-2 py-0.5 rounded-full inline-block bg-green-100 text-green-800">
                    {selectedTransaction.data?.transactionStatus || "N/A"}
                  </span>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-500">Name</p>
                  <p className="mt-1 text-sm text-gray-900">
                    {selectedTransaction.data?.reply?.name || "N/A"}
                  </p>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-500">
                    Date of Birth
                  </p>
                  <p className="mt-1 text-sm text-gray-900">
                    {selectedTransaction.data?.reply?.dob || "N/A"}
                  </p>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-500">New NIN</p>
                  <p className="mt-1 text-sm text-gray-900">
                    {selectedTransaction.data?.newNIN || "N/A"}
                  </p>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-500">
                    New Tracking ID
                  </p>
                  <p className="mt-1 text-sm text-gray-900">
                    {selectedTransaction.data?.newTracking_id || "N/A"}
                  </p>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-500">
                    Old Tracking ID
                  </p>
                  <p className="mt-1 text-sm text-gray-900">
                    {selectedTransaction.data?.old_tracking_id || "N/A"}
                  </p>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-500">
                    Verification Status
                  </p>
                  <p className="mt-1 text-sm text-gray-900">
                    {selectedTransaction.data?.verificationStatus || "N/A"}
                  </p>
                </div>
                <div className="col-span-2">
                  <p className="text-sm font-medium text-gray-500">Message</p>
                  <p className="mt-1 text-sm text-gray-900">
                    {selectedTransaction.data?.message || "N/A"}
                  </p>
                </div>
              </div>
            ) : selectedTransaction.slipLayout === "basic" ? (
              // basic slip layout specific details
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <p className="text-sm font-medium text-gray-500">Date</p>
                  <p className="mt-1 text-sm text-gray-900">
                    {format(
                      new Date(selectedTransaction.createdAt),
                      "dd/MM/yyyy"
                    )}
                  </p>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-500">Status</p>
                  <span className={`mt-1 text-sm font-medium capitalize px-2 py-0.5 rounded-full inline-block ${['success', 'successful', 'verified'].includes(String(selectedTransaction.data?.verification_status || (typeof selectedTransaction.data?.status === 'boolean' ? (selectedTransaction.data?.status ? 'verified' : 'failed') : selectedTransaction.data?.status) || "").toLowerCase()) ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'}`}>
                    {typeof selectedTransaction.data?.status === 'boolean' ? (selectedTransaction.data?.status ? 'Verified' : 'Failed') : selectedTransaction.data?.status || selectedTransaction.data?.verification_status || "N/A"}
                  </span>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-500">NIN</p>
                  <p className="mt-1 text-sm text-gray-900">
                    {selectedTransaction.data?.data?.nin || selectedTransaction.data?.nin_data?.nin || "N/A"}
                  </p>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-500">Name</p>
                  <p className="mt-1 text-sm text-gray-900">
                    {`${selectedTransaction.data?.data?.firstname || selectedTransaction.data?.nin_data?.firstname || ""} ${selectedTransaction.data?.data?.middlename || selectedTransaction.data?.nin_data?.middlename || ""} ${selectedTransaction.data?.data?.surname || selectedTransaction.data?.nin_data?.surname || ""}`.trim() || "N/A"}
                  </p>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-500">Date of Birth</p>
                  <p className="mt-1 text-sm text-gray-900">
                    {selectedTransaction.data?.data?.birthdate || selectedTransaction.data?.nin_data?.birthdate || "N/A"}
                  </p>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-500">Phone</p>
                  <p className="mt-1 text-sm text-gray-900">
                    {selectedTransaction.data?.data?.telephoneno || selectedTransaction.data?.nin_data?.telephoneno || "N/A"}
                  </p>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-500">Reference ID</p>
                  <p className="mt-1 text-sm text-gray-900">
                    {selectedTransaction.data?.reference_id || "N/A"}
                  </p>
                </div>
                <div className="col-span-2">
                  <p className="text-sm font-medium text-gray-500">Message</p>
                  <p className="mt-1 text-sm text-gray-900">
                    {selectedTransaction.data?.message || "N/A"}
                  </p>
                </div>
              </div>
            ) : (
              // Existing modal content for other verification types
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <p className="text-sm font-medium text-gray-500">Date</p>
                  <p className="mt-1 text-sm text-gray-900">
                    {format(
                      new Date(selectedTransaction.createdAt),
                      "dd/MM/yyyy"
                    )}
                  </p>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-500">Data For</p>
                  <p className="mt-1 text-sm text-gray-900">
                    {selectedTransaction.dataFor} -{" "}
                    {selectedTransaction.slipLayout}
                  </p>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-500">
                    Verification Type
                  </p>
                  <p className="mt-1 uppercase text-sm text-gray-900">
                    {selectedTransaction.verifyWith}
                  </p>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-500">Status</p>
                  <span className={`mt-1 text-sm font-medium capitalize px-2 py-0.5 rounded-full inline-block ${['success', 'successful', 'verified'].includes(String(selectedTransaction.data?.user_data?.transactionStatus || selectedTransaction.data?.verification_status || (typeof selectedTransaction.data?.status === 'boolean' ? (selectedTransaction.data?.status ? 'verified' : 'failed') : selectedTransaction.data?.status) || "").toLowerCase()) ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'}`}>
                    {selectedTransaction.data?.user_data?.transactionStatus || (typeof selectedTransaction.data?.status === 'boolean' ? (selectedTransaction.data?.status ? 'Verified' : 'Failed') : selectedTransaction.data?.status) || selectedTransaction.data?.verification_status || "N/A"}
                  </span>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-500">Reference</p>
                  <p className="mt-1 text-sm text-gray-900">
                    {selectedTransaction.data?.user_data
                      ?.transactionReference || "N/A"}
                  </p>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-500">
                    Response Details
                  </p>
                  <p className="mt-1 text-sm text-gray-900">
                    <td className="mt-2">
                      {selectedTransaction.dataFor !== "IPE-Slip" ? (
                        <button
                          onClick={() => handleDownloadSlip(selectedTransaction)}
                          className="text-green-600 border p-1 rounded hover:text-green-800 transition-colors"
                        >
                          Download Slip
                        </button>
                      ) : (
                        <span className="text-gray-400">N/A</span>
                      )}
                    </td>
                  </p>
                </div>
                <div className="col-span-2">
                  <p className="text-sm font-medium text-gray-500">
                    Response Message
                  </p>
                  <p className="mt-1 text-sm text-gray-900">
                    {selectedTransaction.data?.message || "N/A"}
                  </p>
                </div>
              </div>
            )}
          </div>
        )}
      </Modal>
    </div>
  );
}
